import { withStyles } from '@material-ui/core/styles'
import MuiList from '@material-ui/core/List'
import MuiDivider from '@material-ui/core/Divider'
import MuiPopover from '@material-ui/core/Popover'
import MuiTab from '@material-ui/core/Tab'
import MuiGrid from '@material-ui/core/Grid'
import MuiTabList from '@material-ui/lab/TabList'
import MuiTabPanel from '@material-ui/lab/TabPanel'
import MuiSwitch from '@material-ui/core/Switch'
import MuiInputLabel from '@material-ui/core/InputLabel'
import MuiContainer from '@material-ui/core/Container'
import MuiDialog from '@material-ui/core/Dialog'
import { DataGrid as MuiDataGrid } from '@material-ui/data-grid'
import MuiButton from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'

export const List = withStyles(() => ({
  root: {
    minWidth: 300
  }
}))(MuiList)

export const Divider = withStyles((theme) => ({
  root: {
    margin: theme.spacing(1, 2)
  }
}))(MuiDivider)

export const Popover = withStyles((theme) => ({
  root: {
    '& .MuiPaper-rounded': {
      borderRadius: theme.shape.borderRadius * 2
    }
  }
}))(MuiPopover)

export const SquareTab = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 5, 1),
    minWidth: '0px',
    textTransform: 'none',
    fontWeight: theme.palette.inputs.label.semibold,
    '& .MuiTab-wrapper': {
      flexDirection: 'row-reverse',
      alignItems: 'flex-end'
    },
    '&.MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
      marginBottom: 0
    }
  },
  labelIcon: {
    minHeight: '0px'
  }
}))(MuiTab)

export const SquareTabList = withStyles((theme) => ({
  root: {
    marginBottom: '-2px',
    borderBottom: '1px solid #EBEBEB',
    '& .Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: theme.palette.inputs.label.semibold
    }
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
    height: '3px'
  }
}))(MuiTabList)

export const Tab = withStyles((theme) => ({
  root: {
    minHeight: 0,
    padding: theme.spacing(0.5, 3),
    minWidth: 0,
    textTransform: 'none',
    '& .MuiTab-wrapper': {
      flexDirection: 'row-reverse',
      alignItems: 'flex-end'
    },
    '&.MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
      marginBottom: 0
    }
  },
  labelIcon: {
    minHeight: 0
  }
}))(MuiTab)

export const TabList = withStyles((theme) => ({
  root: {
    minHeight: 0,
    backgroundColor: theme.palette.background.light,
    borderRadius: theme.shape.borderRadius * 5,
    '& .MuiTabs-indicator': {
      height: 0
    },
    '& .Mui-selected': {
      borderRadius: theme.shape.borderRadius * 5,
      backgroundColor: theme.palette.secondary.dark,
      '& .MuiTab-wrapper': {
        fontWeight: 700,
        color: theme.palette.common.white
      }
    },
    '& .MuiTab-wrapper': {
      fontWeight: 700,
      color: theme.palette.grey[400]
    },
    '& .MuiTabs-flexContainer': {
      overflowX: 'unset'
    }
  }
}))(MuiTabList)

export const ItemTabPanel = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 0, 0, 0),
    maxWidth: '100%',
    width: '100%'
  }
}))(MuiTabPanel)

export const DistributedGrid = withStyles(() => ({
  root: {
    '& .MuiGrid-item': {
      flexGrow: 1
    }
  }
}))(MuiGrid)

export const LeftGridItem = withStyles((theme) => ({
  root: {
    paddingRight: theme.spacing(1)
  }
}))(MuiGrid)

export const RightGridItem = withStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(1)
  }
}))(MuiGrid)

export const Switch = withStyles((theme) => ({
  switchBase: {
    '&$checked': {
      color: 'white'
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main,
      opacity: 1
    }
  },
  checked: {},
  track: {}
}))(MuiSwitch)

export const InputLabel = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 0, 0.5, 0.5),
    // mirrored input label style (styled text field)
    color: theme.palette.inputs.label.color.dark,
    fontWeight: theme.palette.inputs.label.semibold,
    fontSize: '0.85rem'
  }
}))(MuiInputLabel)

export const TranslucentDialog = withStyles((theme) => ({
  root: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    borderRadius: theme.shape.borderRadius * 2
  }
}))(MuiDialog)

export const DataGrid = withStyles((theme) => ({
  root: {
    borderWidth: 0,
    '& .MuiDataGrid-cell': {
      borderBottom: 0
    },
    '& .MuiDataGrid-columnsContainer': {
      borderBottom: 0
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 700,
      color: theme.palette.common.black,
      fontSize: '0.95rem'
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: 0
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none'
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none'
    }
  },
  cell: {
    color: theme.palette.secondary.main
  },
  columnHeader: {
    '& .MuiDataGrid-columnSeparator': {
      display: 'none'
    },
    '& .MuiDataGrid-columnHeader-draggable .MuiDataGrid-columnHeaderTitleContainer': {
      paddingLeft: 0
    },
    borderWidth: 0
  }
}))(MuiDataGrid)

export const OutlinedSelectButton = withStyles((theme) => ({
  root: {
    marginRight: theme.spacing(1),
    textTransform: 'none',
    minWidth: '100px',
    '& .MuiButton-label': {
      whiteSpace: 'nowrap',
      fontWeight: theme.palette.inputs.label.semibold
    }
  },
  outlinedPrimary: {
    backgroundColor: '#E5EEFF'
  },
  outlinedSecondary: {
    backgroundColor: '#F3F4F6',
    border: '1px solid white',
    color: theme.palette.inputs.label.color.regular,
    '&:hover': {
      border: `1px solid ${theme.palette.grey[200]}`
    }
  }
}))(MuiButton)

export const Container = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3)
  }
}))(MuiContainer)

export const RoundedDarkContainer = withStyles((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius * 3,
    backgroundColor: theme.palette.background.light,
    padding: theme.spacing(2.5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4)
    }
  }
}))(Box)

export const PaddedPaper = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    width: '100%'
  },
  rounded: {
    borderRadius: theme.shape.borderRadius * 3
  }
}))(Paper)
